export default __webpack_public_path__ + "static/media/range.499c8bd6.svg";